import React, { useMemo, useState, useEffect } from "react";
import { Box, List, Divider, CircularProgress, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import MenuHeader from "../shared/menuHeader";
import MenuTabs from "../shared/menuTabs";
import MenuListItem from "../shared/menuListItem";

const BrandMenu = ({ onClose, menuData = [], loading = false }) => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("all");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    setHoveredIndex(null);
  }, [activeTab]);

  const rootBrands = useMemo(() => {
    return menuData.filter(
        (item) =>
            item.ParentId === null ||
            item.ParentId === undefined ||
            item.ParentId === ""
    );
  }, [menuData]);

  const tabs = useMemo(() => {
    return [
      { label: "ΌΛΑ", id: "all" },
      ...rootBrands.map((item) => ({
        label: item.nameEL || item.nameEN,
        id: String(item.id),
      })),
    ];
  }, [rootBrands]);

  const visibleBrands = useMemo(() => {
    if (activeTab === "all") {
      const rootIds = rootBrands.map((item) => String(item.id));

      return menuData.filter(
          (item) =>
              item.ParentId !== null &&
              item.ParentId !== undefined &&
              item.ParentId !== "" &&
              rootIds.includes(String(item.ParentId))
      );
    }

    return menuData.filter(
        (item) => String(item.ParentId) === String(activeTab)
    );
  }, [activeTab, menuData, rootBrands]);

  const handleBrandClick = (brand) => {
    history.push({
      pathname: "/products",
      state: {
        brandId: brand.id,
        brandName: brand.nameEL || brand.nameEN,
      },
    });
    onClose();
  };

  return (
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <MenuHeader title="BRANDS" onClose={onClose} />

        <MenuTabs
            brands={tabs}
            activeTab={activeTab}
            onTabChange={(tab) => {
              setActiveTab(tab);
              setHoveredIndex(null);
            }}
        />

        {loading ? (
            <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
            >
              <CircularProgress />
            </Box>
        ) : (
            <List
                sx={{
                  flex: 1,
                  overflow: "auto",
                  p: 0,
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  "&::-webkit-scrollbar": { display: "none" },
                }}
            >
              {visibleBrands.length === 0 ? (
                  <Box sx={{ p: 2 }}>
                    <Typography variant="body2">Δεν βρέθηκαν brands</Typography>
                  </Box>
              ) : (
                  visibleBrands.map((brand, index) => (
                      <React.Fragment key={brand.id}>
                        <Box
                            onClick={() => handleBrandClick(brand)}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                            sx={{ cursor: "pointer" }}
                        >
                          <MenuListItem
                              icon={brand.icon}
                              name={brand.nameEL || brand.nameEN}
                              isHighlight={false}
                              isHovered={hoveredIndex === index}
                              onMouseEnter={() => setHoveredIndex(index)}
                              onMouseLeave={() => setHoveredIndex(null)}
                          />
                        </Box>

                        {index < visibleBrands.length - 1 && (
                            <Divider
                                sx={{
                                  backgroundColor: "#B9B9B9",
                                  margin: "0px",
                                }}
                            />
                        )}
                      </React.Fragment>
                  ))
              )}
            </List>
        )}
      </Box>
  );
};

export default BrandMenu;